define('supplierImprintTechnologiesCreateEditView',[
  'module',
  'underscore',
  'marionette',
  'backbone',
  'jquery',
  'dialogFormView',
  'template!supplierImprintTechnologiesCreateEditTpl',
  'savingBehavior',
  'dynamicTextView',
  'app'
], function (
  module,
  _,
  Marionette,
  Backbone,
  $,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  DynamicTextView,
  App
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      individualPrinting: '#individualPrinting'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input': 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm',
      'change @ui.individualPrinting': 'onChangeIndividualPrinting',
      'change .checkbox-input': 'onChangeCheckboxInput'
    },

    regions: {
      nameRegion: '.name-region'
    },

    className: 'profile-create-edit',

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'code', type: 'required'}
    ],

    onChangeCheckboxInput: function (e) {
      var inp = $(e.target);
      this.model.set(inp.data('field-name'), inp.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onChangeIndividualPrinting: function () {
      this.model.set('individualPrinting', this.ui.individualPrinting.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    initialize: function (options) {
      this.model = options.itModel;
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    /**
     * Convert simple values structure to DynamicText format
     * to properly initialize the DynamicText component
     */
    convertValuesToDynamicText: function(nameData) {
        var dynamicTextData = {
            dynamicTextLocalizeds: [],
            refDynamicText: null,
            refGlossary: null
        };

        if (nameData) {
            var values = nameData.get('values');
            if(values) {
                _.each(values, function (text, locale) {
                    dynamicTextData.dynamicTextLocalizeds.push({
                        locale: locale,
                        stdtext: text
                    });
                });
            }
        }

        return dynamicTextData;
    },

    /**
     * Convert DynamicText structure back to simple values format
     * to maintain API compatibility
     */
    convertDynamicTextToValues: function(dynamicTextModel) {
        var values = {};
        if (dynamicTextModel && dynamicTextModel.get && dynamicTextModel.get('dynamicTextLocalizeds')) {
            var localizeds = dynamicTextModel.get('dynamicTextLocalizeds');
            if (localizeds && localizeds.models) {
                _.each(localizeds.models, function(localizedModel) {
                    var locale = localizedModel.get('locale');
                    var text = localizedModel.get('stdtext');
                    if (locale && text) {
                        values[locale] = text;
                    }
                });
            }
        }
        return { values: values };
    },

      onConfirm: function () {
          if (this.validate(this.fieldsToValidate)) {
              var nameValues = this.convertDynamicTextToValues(this.nameDtView.model);
              this.model.set('name', nameValues);
              this.model.save();
          }
      },

      onSave: function () {
          // Build a plain payload for the grid; enforce `name` to be `{ values: … }`
          var updated = this.model.toJSON();
          updated.name = this.convertDynamicTextToValues(this.nameDtView.model);

          // Notify the opener with the updated attributes
          this.triggerMethod('saved', updated);
          this.hide();
      },

      onShow: function () {
          $.material.init();

          var nameModel = this.model.get('name');
          var dynamicTextData = this.convertValuesToDynamicText(nameModel);
          nameModel = App.request('products-translation:dynamictext-model', dynamicTextData);

          this.nameDtView = new DynamicTextView({
              model: nameModel,
              noSaving: true,
              hideGlossary: true
          });
          this.nameDtView.dataUpdated = _.bind(function () {
              this.triggerMethod('enable:cancel:confirm');
          }, this);
          this.getRegion('nameRegion').show(this.nameDtView);
      },


    onSaveError: function (model, response) {
      if (response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    }
  });

  module.exports = CreateEditLayoutView;
});
